import headerImage from "../Assets/Images/Misc/include-header.jpg";
import bgImage from "../Assets/Images/Misc/include-bg.jpg";
import qrImage from "../Assets/Images/Misc/include-qr.jpg";

const CallForIdeas = () => {
  return (
    <div
      className="min-h-screen  w-full p-4 bg-no-repeat bg-cover bg-fixed"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="mx-auto w-full max-w-4xl p-0 mb-20  border-2 border-black bg-white ">
        <div className="w-full  bg-white font-sans text-xs text-justify ">
          <div className=" relative p-2 text-center">
            <a href="https://include-call-for-ideas.grantplatform.com/">
              <button className="hidden  md:block px-4 py-2 bg-black bg-opacity-40 rounded-md  text-[#f5d08d] text-[100%] absolute right-[11%] bottom-[40%]">
                Submit Idea
              </button>{" "}
            </a>
            <img
              src={headerImage}
              alt="Header"
              className="w-full object-cover"
            />
          </div>
        </div>
        <div className="w-full px-8 pt-2 pb-2 bg-white font-sans text-xs text-justify bg-no-repeat bg-top">
          <div className="">
            <span className="text-sm">
              Due to global warming and climate change, various natural
              disasters such as floods, tidal surges, and heatwaves are
              occurring in different regions of the country. To address these
              adverse effects, the Innovations for Climate-smart Urban
              Development (INCLUDE) project is being implemented in the
              municipalities of Chapainawabganj, Charghat, Gaibandha, and
              Sirajganj under the Local Government Engineering Department
              (LGED), which operates under the Local Government Division (LGD)
              of the Ministry of Local Government, Rural Development, and
              Cooperatives of Bangladesh. The project is funded by the German
              Federal Ministry for Economic Cooperation and Development (BMZ)
              and implemented through GIZ.
            </span>
            <br />
            <br />
            <span className="text-sm">
              Under this project, a call for innovative solutions has been
              launched to build climate-resilient cities in the participating
              municipalities. Your innovative, digital, inclusive, realistic and
              practical ideas, especially those offering practical and
              sustainable solutions for vulnerable areas and communities, can
              guide the way toward real change in addressing local climate
              challenges. The winning ideas will be implemented by the
              respective municipalities.
            </span>
            <p className="text-sm">
              <strong>
                Selected participants will receive special training,
                certificates, publicity, and opportunities for recognition.
                Implemented solutions will include a commemorative nameplate as
                a mark of recognition, serving as a lasting example.
              </strong>
              <br />
              <br />
              <strong>Eligible Municipalities:</strong>
              Chapainawabganj, Charghat, Sirajganj, Gaibandha.
              <br />
              <br />
              <strong>Who Can Participate:</strong> Participation is open to
              general citizens, any legally operating community-based group,
              civil society organizations (CSOs), NGOs, educational
              institutions, relevant individuals or entities from the private
              sector. However, applicants must submit solutions specifically
              relevant to one of the four municipalities mentioned.
              <br />
              <br />
              Your idea must be based on local problems, digital, inclusive,
              innovative, feasible for implementation.
            </p>
          </div>

          <div className="text-sm ">
            <br />
            <strong>
              Submission Deadline:
              <span className="text-red-500">August 31, 2025</span>
            </strong>
            <br />
            <br />
            <div className="sm:flex  gap-2 items-center">
              <div className="w-full sm:max-w-[calc(100%-250px)]">
                <strong>Submission Process:</strong>
                <br />
                <div className="text-left">
                  <p className="w-full">
                    To submit online scan the QR code or visit
                    <br />
                    <p
                      href="https://include-call-for-ideas.grantplatform.com/"
                      className="text-blue-600 hover:underline "
                    >
                      https://include-call-for-ideas.grantplatform.com/
                    </p>
                  </p>
                </div>
                <br />
                To submit in person, collect the form from the respective
                municipal office.
              </div>
              <div className="text-center lg:text-right md:ml-auto">
                <img src={qrImage} alt="QR Code" className=" inline-block" />
                <a href="https://include-call-for-ideas.grantplatform.com/">
                  <button className=" px-4 py-2 bg-black bg-opacity-40 rounded-md  text-[#f5d08d] w-[150px] ">
                    Submit Idea
                  </button>
                </a>
              </div>
            </div>

            <strong>For any assistance,</strong>
            <br />
            <p>
              <strong>Mobile: </strong>01324175193,<strong>Email:</strong>
            </p>
            <a
              href="mailto:include.call.for.ideas@gmail.com?subject=Idea%20Submission"
              className="text-blue-600 hover:underline"
            >
              include.call.for.ideas@gmail.com
            </a>
          </div>

          <p className="text-sm">
            Your innovative idea can change the future of your city. The time to
            act is now.
            <br />
            <br />
            <span className="text-xs">
              This initiative is implemented by GIZ and the municipalities of
              Chapainawabganj, Charghat, Sirajganj, and Gaibandha.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CallForIdeas;
